import LenderActionTypes from "./lender.types";

/** ***************** GET LENDER LIST START *********************** */
export const getLenderListStart = (getData: any) => ({
  type: LenderActionTypes.GET_LENDER_LIST_START,
  payload: getData,
});

export const getLenderListSuccess = (successData: any) => ({
  type: LenderActionTypes.GET_LENDER_LIST_SUCCESS,
  payload: successData,
});

export const getLenderListFailure = (failureData: any) => ({
  type: LenderActionTypes.GET_LENDER_LIST_FAILURE,
  payload: failureData,
});

export const getLenderListResponseResetStart = () => ({
  type: LenderActionTypes.GET_LENDER_LIST_RESPONSE_RESET,
});

export const getLenderListResponseChanged = () => ({
  type: LenderActionTypes.GET_LENDER_LIST_RESPONSE_CHANGED,
});

/** ***************** GET LENDER LIST END *********************** */

/** ***************** ADD LENDER DETAILS START *********************** */
export const addLenderDetailsStart = (addData: any) => ({
  type: LenderActionTypes.ADD_LENDER_DETAILS_START,
  payload: addData,
});

export const addLenderDetailsSuccess = (successData: any) => ({
  type: LenderActionTypes.ADD_LENDER_DETAILS_SUCCESS,
  payload: successData,
});

export const addLenderDetailsFailure = (failureData: any) => ({
  type: LenderActionTypes.ADD_LENDER_DETAILS_FAILURE,
  payload: failureData,
});

export const addLenderDetailsResponseResetStart = () => ({
  type: LenderActionTypes.ADD_LENDER_DETAILS_RESPONSE_RESET,
});

export const addLenderDetailsResponseChanged = () => ({
  type: LenderActionTypes.ADD_LENDER_DETAILS_RESPONSE_CHANGED,
});

/** ***************** ADD LENDER DETAILS END *********************** */

/** ***************** UPDATE LENDER DETAILS START *********************** */
export const updateLenderDetailsStart = (updateData: any) => ({
  type: LenderActionTypes.UPDATE_LENDER_DETAILS_START,
  payload: updateData,
});

export const updateLenderDetailsSuccess = (successData: any) => ({
  type: LenderActionTypes.UPDATE_LENDER_DETAILS_SUCCESS,
  payload: successData,
});

export const updateLenderDetailsFailure = (failureData: any) => ({
  type: LenderActionTypes.UPDATE_LENDER_DETAILS_FAILURE,
  payload: failureData,
});

export const updateLenderDetailsResponseResetStart = () => ({
  type: LenderActionTypes.UPDATE_LENDER_DETAILS_RESPONSE_RESET,
});

export const updateLenderDetailsResponseChanged = () => ({
  type: LenderActionTypes.UPDATE_LENDER_DETAILS_RESPONSE_CHANGED,
});

/** ***************** UPDATE LENDER DETAILS END *********************** */

/** ***************** DELETE LENDER DETAILS START *********************** */
export const deleteLenderDetailsStart = (deleteData: any) => ({
  type: LenderActionTypes.DELETE_LENDER_DETAILS_START,
  payload: deleteData,
});

export const deleteLenderDetailsSuccess = (successData: any) => ({
  type: LenderActionTypes.DELETE_LENDER_DETAILS_SUCCESS,
  payload: successData,
});

export const deleteLenderDetailsFailure = (failureData: any) => ({
  type: LenderActionTypes.DELETE_LENDER_DETAILS_FAILURE,
  payload: failureData,
});

export const deleteLenderDetailsResponseResetStart = () => ({
  type: LenderActionTypes.DELETE_LENDER_DETAILS_RESPONSE_RESET,
});

export const deleteLenderDetailsResponseChanged = () => ({
  type: LenderActionTypes.DELETE_LENDER_DETAILS_RESPONSE_CHANGED,
});

/** ***************** DELETE LENDER DETAILS END *********************** */

/** ***************** FETCH LENDER DETAILS START *********************** */
export const fetchLenderDetailsStart = (fetchData: any) => ({
  type: LenderActionTypes.FETCH_LENDER_DETAILS_START,
  payload: fetchData,
});

export const fetchLenderDetailsSuccess = (successData: any) => ({
  type: LenderActionTypes.FETCH_LENDER_DETAILS_SUCCESS,
  payload: successData,
});

export const fetchLenderDetailsFailure = (failureData: any) => ({
  type: LenderActionTypes.FETCH_LENDER_DETAILS_FAILURE,
  payload: failureData,
});

export const fetchLenderDetailsResponseResetStart = () => ({
  type: LenderActionTypes.FETCH_LENDER_DETAILS_RESPONSE_RESET,
});

export const fetchLenderDetailsResponseChanged = () => ({
  type: LenderActionTypes.FETCH_LENDER_DETAILS_RESPONSE_CHANGED,
});

/** ***************** FETCH LENDER DETAILS END *********************** */

/** ******************** LENDER LIST FETCH START **************** */
export const lenderListFetchStart = (lenderList: any) => ({
  type: LenderActionTypes.LENDER_LIST_FETCH_START,
  payload: lenderList,
});

export const lenderListFetchSuccess = (success: any) => ({
  type: LenderActionTypes.LENDER_LIST_FETCH_SUCCESS,
  payload: success,
});

export const lenderListFetchFailure = (failure: any) => ({
  type: LenderActionTypes.LENDER_LIST_FETCH_FAILURE,
  payload: failure,
});

export const lenderListResponseResetStart = () => ({
  type: LenderActionTypes.LENDER_LIST_RESPONSE_RESET_START,
});

export const lenderListFetchResponseChanged = () => ({
  type: LenderActionTypes.LENDER_LIST_FETCH_RESPONSE_CHANGED,
});
/** ******************** LENDER LIST FETCH END **************** */
